import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	congrats: {
		id: 'partner.accessSuccess.congrats',
		defaultMessage: 'Request submitted!',
		description: 'Tells the user that their request access form has been submitted successfully',
	},
	successText: {
		id: 'partner.accessSuccess.downloadApp',
		defaultMessage:
			'We’ve sent a request to your administrator to look at your request for verification. You should hear back from them within 1 week about whether you will have access.{breakingLine}We recommend downloading the Calm app and starting your journey there.{breakingLine}You’ll find a comprehensive library of content from Meditations, Sleep Stories, and Music. All to help you manage stress, mental health, and so much more.{breakingLine}',
		description: 'Success body text',
	},
});
